/**
 * Formata a data de liberação administrativa (releasedAt).
 *
 * releasedAt é um timestamp real (momento do clique), então a formatação usa o fuso
 * local do usuário — formatar em UTC exibiria o dia seguinte para liberações noturnas.
 * Não usar para campos data-pura (ex: entryDate), que devem permanecer em UTC.
 */
export const formatReleaseDate = (date?: string | Date | null): string => {
  if (!date) return '-';
  return new Date(date).toLocaleDateString('pt-BR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};
